<template>
    <!-- Show only mobile users and desktop users for now.-->
    <div
        v-if="!loading && !isTab && bannerContent && showToUser"
        class="vrm-new-features-banner-container"
    >
        <div class="vrm-new-features-banner">
            <div class="textual-information-container">
                <img :src="imageSourceVrmLogo" class="vrm-logo" />
                <!--To change the content of the banner , please change config.js file vrm-front/public. Please
                    also run it after changes to check for styling issues-->
                <div class="title-text-container">
                    <span class="title-text">
                        {{
                            this.$t(bannerContent.title, {
                                i18nFallback: bannerContent.titleFallback,
                            })
                        }}
                    </span>
                </div>
                <!--Using v-html to ensure br tag is rendered as an html tag instead of a string -->
                <div v-if="!isMobile" class="sub-title-text-container">
                    <span
                        class="sub-title-text-banner"
                        v-html="
                            this.$t(bannerContent.subTitle, {
                                i18nFallback: bannerContent.subTitleFallback,
                            })
                        "
                    ></span>
                </div>
                <div v-if="isMobile" class="sub-title-text-container">
                    <span
                        class="sub-title-text-banner"
                        v-html="
                            this.$t(bannerContent.subTitleMobile, {
                                i18nFallback: bannerContent.subTitleMobileFallback,
                            })
                        "
                    ></span>
                </div>
            </div>
            <div class="image-container">
                <img :src="bannerImage" class="banner-image" />
            </div>
            <a :href="bannerContent.readMore" target="_blank" class="read-more-link">
                <span class="read-more-text">
                    {{
                        $t('new_features_banner.read_more', {
                            i18nFallback: 'Read more',
                        })
                    }}
                </span>
            </a>
            <a class="cross-container" @click="hideBanner()">
                <img class="new-features-banner-cross" src="img/new-features-banner-cross.svg" />
            </a>
        </div>
    </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularDirective, ngInject } from '@/vue/decorators/angular-interop';

@Component({
    data() {
        return {
            bannerContent: null,
        };
    },
    created() {
        this.showToUser = true;
    },
})
@AngularDirective('vrm-new-features-banner')
//This component is currently used in the dashboard
export default class VrmNewFeaturesBanner extends Vue {
    @ngInject()
    AppearanceService;

    @ngInject()
    ApiService;

    loading = true;
    showToUser = true;

    /*Using 450 px and 1280px because that is defined as being a "mobile" and "tab" 
    in grid.less (project variables)! Also tried using other methods to detect if a 
    mobile is being currently used but they classified some tabs as also mobile. 
    This method seems to be the most reliable!*/
    isTab = window.innerWidth < 1280 && window.innerWidth > 450;
    isMobile = window.innerWidth < 450;
    async mounted() {
        window.addEventListener('resize', this.handleResize);
        await this.checkUserPreferences();
        try {
            const response = await fetch('newFeaturesBanner.json');
            this.bannerContent = await response.json();
        } catch (error) {
            this.showToUser = false;
        }
    }

    //Checking if the mobile condition is still met on screen resize!
    handleResize() {
        this.isTab = window.innerWidth < 1280 && window.innerWidth > 450;
        this.isMobile = window.innerWidth < 450;
    }

    /*Used to check if the user has ever closed the banner before.
    If the user has, set showToUser to false and do not show the banner*/
    async checkUserPreferences() {
        try {
            let response = await this.ApiService.getUserPreferences();
            // Set show based on the API response if the user has ever closed the banner or not
            this.showToUser = response.hideWatchAppsDashboardBanner !== 1;
        } catch (error) {
            this.showToUser = false;
        } finally {
            // Set loading to false whether the API call succeeded or failed
            this.loading = false;
        }
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    }

    /*Only show the banner to each user once. Triggered when user closes the banner.
    Sets showToUser to false and sends the preferences back to the server!
    */
    async hideBanner() {
        this.showToUser = false; //hide the banner

        try {
            // Send the preferences back to the server using PUT
            await this.ApiService.hideBanner();
        } catch (error) {
            //Do nothing
        }
    }

    //Retrieving different images for dark and light mode!
    get imageSourceVrmLogo() {
        return this.AppearanceService.isDarkModeActive()
            ? '/img/victron_logo_white.png'
            : '/img/victron_logo_black.png';
    }

    get bannerImage() {
        if (this.isMobile) {
            return this.AppearanceService.isDarkModeActive()
                ? this.bannerContent.bannerImageDarkMobile
                : this.bannerContent.bannerImageLightMobile;
        } else {
            return this.AppearanceService.isDarkModeActive()
                ? this.bannerContent.bannerImageDarkDesktop
                : this.bannerContent.bannerImageLightDesktop;
        }
    }
}
</script>
